export default function isNumber(val: string): boolean {
  return !Number.isNaN(Number(val));
}
